<template>
  <div>
    <b-button
      size="sm"
      style="margin: 20px"
      variant="darkblue"
      @click="$router.push('/vireed')"
      title="Back to projects list"
    >
      <font-awesome-icon :icon="['fas', 'caret-left']" />
      Projects
    </b-button>

    <vireedSidebarProject
      :projectName="name"
      v-on:version-changed="changeVersion()"
      :userRole="userRole"
      :projectVersion="projectVersion"
      :key="sideBarKey"
    ></vireedSidebarProject>

    <div style="height: 100vh; max-width: 100%" :key="videoKey">
  
      <b-row class="justify-content-center" style="margin: 0px 5px" v-if="!updateProjectTitle">
        <h6 class="pointerEltSB" style="padding-bottom:12px; text-align:center">
          <span
          @click="newName = name; updateProjectTitle = !updateProjectTitle"
          v-if="!updateProjectTitle && (userRole === 'owner' || userRole === 'admin')"
          variant="emptyB"
          >
            {{ name }}
            <small>
              <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            </small>
          </span>
          <span
          v-if="!updateProjectTitle && (userRole === 'viewer' || userRole === 'editor')"
          class="pointerEltVideo"
          >
            {{ name }}
          </span>
        </h6>
      </b-row>
      <b-row class="justify-content-center" style="margin: 0px 5px" v-if="updateProjectTitle">
        <b-form style="margin:0px; padding:0px" @submit.prevent="updateTitle">
          <b-input-group size="sm" prepend="Title: ">
            <b-input size="sm" type="text" v-model="newName"></b-input>
            <b-button size="sm" variant="bordered" @click="updateTitle">
              <font-awesome-icon
              class="pointerEltSB"
              style="color: #14bf98"
              :icon="['fas', 'check']"
              />
            </b-button>
            <b-button size="sm" variant="borderedx" @click="cancelTitle">
              <font-awesome-icon
              class="pointerEltSB"
              style="color: red"
              :icon="['fas', 'times']"
              />
            </b-button>
          </b-input-group>
        </b-form>
      </b-row>
      <b-row class="justify-content-center" style="margin: 0px 5px">
        <b-button
        v-b-toggle.sidebarProject
        title="Click to manage project versions"
        variant="emptyB"
        size="sm"
        >
          <span :data-descr="' (from: '+videoTitle+')'" >
            v{{projectVersion}}&nbsp; 
            <small><font-awesome-icon :icon="['fas', 'tools']" /></small>
          </span>
        </b-button>
      </b-row>

      <b-row class="justify-content-center" style="margin: 10px 5px">
        <small
          style="text-align: center; margin: 0px 5px; padding: 2px"
          title="Project creation date"
        >
          <font-awesome-icon :icon="['fas', 'calendar-minus']" />
          {{ createdAt }}
        </small>

        <small
          style="text-align: center; margin: 0px 5px; padding: 2px"
          title="Owner of the project"
        ><i><strong>
          By {{ owner }}
          </strong></i>
        </small>
        <small
          style="text-align: center; margin: 0px 5px; padding: 2px"
          title="Project last update"
        >
          <font-awesome-layers>
            <font-awesome-icon
              :icon="['fas', 'circle']"
              transform="shrink-12"
            />
            <font-awesome-icon :icon="['fas', 'redo-alt']" />
          </font-awesome-layers>
          {{ lastUpdated }} &nbsp;
        </small>
      </b-row>

      <b-row class="justify-content-center align-items-center" style="margin: 10px 5px">
        
        <b-button
        variant="emptyB"
        style="text-align: center"
        v-b-modal.modal-see-users
        title="Number of collaborators for the project, click to manage"
        size="sm"
        >
          <span data-descr="Collaborator(s)">
            <font-awesome-icon :icon="['fas', 'user-tie']" />
            {{ collabsList.length }}
          </span>
        </b-button>

        <b-button
        variant="emptyB"
        style="text-align: center"
        title="Number of teams in the project, click to manage"
        v-b-modal.modal-see-teams
        size="sm"
        >
          <span data-descr="Team(s)">
            <font-awesome-icon :icon="['fas', 'user-friends']" />
            {{ teamsProject.length }}
          </span>
        </b-button>

        <b-button
        variant="emptyB2"
        style="text-align: center; cursor:default"
        title="Annotations, annotations with comments, comments"
        size="sm"
        >
          <font-awesome-icon
            :icon="['fas', 'highlighter']"
            transform="flip-h"
          />
          {{ totalAnnotCount.annotations }} &nbsp;
          <font-awesome-layers>
            <font-awesome-icon
              :icon="['fas', 'highlighter']"
              transform="flip-h shrink-3 left-5"
            />
            <font-awesome-icon
              :icon="['fas', 'comment-dots']"
              transform="shrink-3 up-5 right-4"
            />
          </font-awesome-layers>
          {{ totalAnnotCount.annotationsWithComment }} &nbsp;
          <font-awesome-icon :icon="['fas', 'comment-dots']" />
          {{ totalAnnotCount.comments }} &nbsp;
        </b-button>
      </b-row>

      <b-row class="justify-content-center" style="margin: 10px 5px 0px">

      <b-button
        variant="emptyB"
        size="sm"
        style="text-align: center"
        title="Project description, click to modify"
        v-if="
          !updateProjectDescription &&
          (userRole === 'owner' || userRole === 'admin')
        "
        @click="
          updateProjectDescription = !updateProjectDescription;
          newDescription = description;
        "
      >
        <span data-descr="Description: ">

          <font-awesome-layers>
            <font-awesome-icon :icon="['fas', 'file-alt']" />
            <font-awesome-icon
              :icon="['fas', 'pencil-alt']"
              transform="shrink-4 up-6 right-9 flip-v rotate-180"
            /> 
          </font-awesome-layers>
          &nbsp;
        </span>
        {{ description }}
      </b-button>

      <small
        class="pointerEltVideo"
        style="text-align: center; margin: 0px 15px"
        title="Project description"
        v-if="
          !updateProjectDescription &&
          (userRole === 'viewer' || userRole === 'editor')
        "
      >
        <font-awesome-layers>
          <font-awesome-icon
            :icon="['fas', 'file-alt']"
          /> </font-awesome-layers
        >&nbsp; {{ description }}
      </small>

      <b-form-group
      class="pointerEltVideo"
      style="text-align: center; margin: 0px 15px"
      label-size="sm"
      title="Project description"
      v-if="updateProjectDescription"
      @submit.prevent="newDescription">
        <b-input-group size="sm" prepend="Description: ">
          <b-form-textarea rows="3" style="min-height:50px; min-width:300px" size="sm" v-model="newDescription"></b-form-textarea>
          <b-button variant="bordered" @click="updateDescription">
            <small><font-awesome-icon class="pointerEltSB" style="color: #14bf98" :icon="['fas', 'check']" /></small>
          </b-button>
          <b-button variant="borderedx" @click="cancelDescription">
            <small><font-awesome-icon class="pointerEltSB" style="color: red" :icon="['fas', 'times']" /></small>
          </b-button>
        </b-input-group>
      </b-form-group>

      </b-row>

      <b-row id="content" style="margin: 40px 0px">
        <b-col cols="12" md="7" sm="7">
          <div
            id="video_wrap"
            style="
              position: sticky;
              height: max-content;
              border-radius: 5px 0 0 5px;
              box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
            "
          >
            <div
              id="wrap-1"
              style="
                border-radius: 5px;
                background-color: #f2f2f2;
                padding-bottom: 35px;
                margin-bottom: 30px;
              "
            >
              <div>
                <b-button
                  class="btn-block"
                  style="margin-bottom: 10px"
                  variant="darkblue"
                  title="Open chatroom w/ all collaborators"
                  @click="popupWindow"
                >
                  <font-awesome-icon :icon="['fas', 'comments']" />
                  Project Chatroom
                </b-button>
              </div>
              <div id="videoPlayer" class="noDisplayVideo">
                <video
                  v-bind:id="'vid-' + this.$route.params.projectId"
                  class="video-js"
                  controls
                  preload="auto"
                  width="720"
                  height="405"
                  style="border-radius: 5px"
                  vjs-big-play-centered
                ></video>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'to_encode'">
                <b-alert variant="danger" show
                  >Putting video to encoding</b-alert
                >
              </div>

              <div
                v-if="
                  noVideo === false &&
                  this.statusVideo === 'waiting_for_encoding'
                "
              >
                <b-alert variant="danger" show>Waiting for encoding</b-alert>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'error'">
                <b-alert variant="danger" show>Error encoding video</b-alert>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'to_stop'">
                <b-alert variant="danger" show>Stopping encoding</b-alert>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'stopped'">
                <b-alert variant="danger" show>Encoding stopped</b-alert>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'restart'">
                <b-alert variant="danger" show>Restarting encoding</b-alert>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'encoding'">
                <b-alert variant="danger" show>Encoding video</b-alert>
              </div>

              <div v-if="noVideo === false && this.statusVideo === 'uploading'">
                <b-alert variant="danger" show>Uploading video</b-alert>
              </div>

              <div v-if="noVideo === true">
                <b-alert variant="danger" show
                  >This video has been deleted and cannot be displayed
                  anymore</b-alert
                >
              </div>

              <b-row
                v-if="annotOn === false"
                class="divGlobal-user align-items-center pointerEltSB"
                v-b-toggle.collapse
                @click="collapse"
                title="Click to show/hide all annotations on one line"
              >
                <div class="divName col">
                  <b-avatar
                    style="background-color: transparent; color: black"
                    size="35"
                    class="mr-3"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'users']"
                      title="All collaborators"
                    ></font-awesome-icon>
                  </b-avatar>
                  All
                  <!--
                  <small>
                    (<font-awesome-icon :icon="['fas', 'user-tie']" />
                    {{collabsList.length}}
                    <font-awesome-icon :icon="['fas', 'user-friends']" />
                    {{teamsProject.length}})
                  </small>
                  -->
                </div>
                <b-col class="hr-user">
                  <div
                    style="height: 5px; background: gray; margin-right: 4.22px"
                  ></div>
                </b-col>
                <b-form-checkbox disabled v-model="allUsersCheck" />
              </b-row>

              <b-row
                v-else
                class="divGlobal-user align-items-center pointerEltSB"
              >
                <div class="divName col">
                  <div
                    class="status disconnected"
                    v-bind:class="{ connected: true }"
                  ></div>

                  <b-avatar
                    badge-variant="transparent"
                    badge-offset="-2px"
                    :style="{ 'background-color': colorAvatar }"
                    size="35"
                    class="mr-3"
                  >
                    <template #badge>
                      <font-awesome-icon
                        v-if="userRole === 'viewer'"
                        :icon="['fas', 'eye']"
                        style="color: black"
                      />
                      <font-awesome-icon
                        v-if="userRole === 'editor'"
                        :icon="['fas', 'edit']"
                        style="color: black"
                      />
                      <font-awesome-icon
                        v-if="userRole === 'admin'"
                        :icon="['fas', 'cog']"
                        style="color: black"
                      />
                      <font-awesome-icon
                        v-if="userRole === 'owner'"
                        :icon="['fas', 'cog']"
                        style="color: #ba0000"
                      />
                    </template>
                    {{ initials }}
                  </b-avatar>
                  {{ username }}
                </div>
                <b-col
                  class="hr-user"
                  title="Expand the marker to the exact timeframe of your annotation"
                >
                  <div
                    style="height: 5px; background: gray; margin-right: 4.22px"
                  ></div>
                </b-col>
                <b-form-checkbox
                  style="visibility: hidden"
                  disabled
                  v-model="allUsersCheck"
                />
              </b-row>

              <b-collapse
                :key="collabCollapsKey"
                id="collapse"
                v-if="annotOn === false"
                visible
                v-model="expandBar"
              >
                <div v-for="(collab, idx) in collabsList" :key="idx">
                  <b-row class="divGlobal-user align-items-center">
                    <div
                      class="divName col pointerEltSB"
                      :title="
                        'Collaborator: ' +
                        collab.pseudo +
                        ', role: ' +
                        collab.role +
                        '. Click for all info'
                      "
                      style="cursor: pointer"
                      @click="userSelected = collab"
                      v-b-modal.modal-username
                    >
                      <div
                        :id="`${collab.pseudo}-connect`"
                        class="status disconnected"
                        v-bind:class="{ connected: collab.isConnected }"
                      ></div>

                      <b-avatar
                        badge-variant="transparent"
                        badge-offset="-2px"
                        :style="{ 'background-color': collab.color }"
                        size="35"
                        class="white--text mr-3"
                      >
                        <template #badge>
                          <font-awesome-icon
                            v-if="collab.role === 'viewer'"
                            :icon="['fas', 'eye']"
                            style="color: black"
                          />
                          <font-awesome-icon
                            v-if="collab.role === 'editor'"
                            :icon="['fas', 'edit']"
                            style="color: black"
                          />
                          <font-awesome-icon
                            v-if="collab.role === 'admin'"
                            :icon="['fas', 'cog']"
                            style="color: black"
                          />
                          <font-awesome-icon
                            v-if="collab.role === 'owner'"
                            :icon="['fas', 'cog']"
                            style="color: #ba0000"
                          />
                        </template>
                        {{ collab.initials }}
                      </b-avatar>
                      {{ collab.pseudo }}
                      <div
                        class="badge badge-light"
                        style="
                          position: absolute;
                          z-index: 2;
                          top: 0px;
                          right: 0px;
                        "
                        v-if="
                          collab.origin === 'team' && collab.teams.length === 1
                        "
                        :title="'From Team: ' + collab.teams[0]"
                      >
                        <font-awesome-icon :icon="['fas', 'user-friends']" />
                      </div>
                      <div
                        class="badge badge-light"
                        style="
                          position: absolute;
                          z-index: 2;
                          top: 0px;
                          right: 0px;
                        "
                        v-if="
                          collab.origin === 'team' && collab.teams.length > 1
                        "
                        :title="'From ' + collab.teams.length + ' Teams'"
                      >
                        <font-awesome-icon :icon="['fas', 'user-friends']" />
                        <small
                          ><strong>{{ collab.teams.length }}</strong></small
                        >
                      </div>
                    </div>
                    <div :class="'hr-user col'">
                      <div
                        style="
                          height: 5px;
                          background: gray;
                          margin-right: 4.22px;
                        "
                      ></div>
                    </div>

                    <b-form-checkbox
                      v-model="selected"
                      :value="collab.pseudo"
                      :color="collab.color"
                      @change="checkboxChecked(collab.pseudo)"
                    >
                    </b-form-checkbox>
                  </b-row>
                </div>
              </b-collapse>
<!--
              <b-row class="justify-content-around">
                <b-button
                  v-if="userRole === 'admin' || userRole === 'owner'"
                  style="margin: 40px 5px 10px 5px"
                  v-b-modal.modal-prevent-closing
                  variant="msstreamblue"
                  title="Modify collaborators for the project"
                >
                  <font-awesome-icon :icon="['fas', 'user-tie']" />&nbsp
                  Collaborators
                </b-button>

                <b-button
                  v-if="userRole === 'admin' || userRole === 'owner'"
                  style="margin: 40px 5px 10px 5px"
                  v-b-modal.modal-add-team
                  variant="msstreamblue"
                  title="Modify Teams for the project"
                >
                  <font-awesome-icon :icon="['fas', 'user-friends']" />&nbsp
                  Teams
                </b-button>
              </b-row>
-->
            </div>
          </div>          
        </b-col>

        <b-col cols="12" md="5" sm="5">
          <VireedPlayer
            v-on:openannot="changeAnnot()"
            v-on:removecollapse="removeCollapse()"
            v-on:version="changeVersion()"
            v-on:userAdds="reloadProjectUser()"
            v-on:usersRemove="reloadProjectUserAfterTeamDeletion()"
            v-on:role="reloadProjectUser()"
            v-on:teamEdit="reloadProjectUserAfterTeamEdit()"
            v-on:projectInfoUpdated="reloadProjectInfo()"
            @userJoined="userJoined"
            @userLeft="userLeft"
            v-bind="post"
            :selected-people="selected"
            :user-role="userRole"
            :expand="expand"
            :roleChanged="roleChanged"
            :key="videoPlayerKey"
            style="
              position: sticky;
              height: max-content;
              border-radius: 5px 0 0 5px;
            "
          ></VireedPlayer>
        </b-col>

        <!--
        <b-col cols="12" md="4" sm="12">
          <div id="collabsList" class="pa-3" :key="collaboratorsListKey">
            <div id="ProjectInfo">
              <b-tabs content-class="mt-3">
                <b-tab title="collaborators" active>
                  <div id="collaborators">
                      
                      <b-button
                            v-if="userRole === 'admin' || userRole === 'owner'"
                            v-b-modal.modal-prevent-closing
                            variant="msstreamblue"
                          >
                            Add a collaborator
                            <b-icon icon="plus-circle"></b-icon>
                      </b-button>


                    <ul class="pa-0" :key="collabsKey">
                      <li v-for="(collab, idx) in collabsList" :key="idx">
                        <div>
                          <div
                            :id="`${collab.pseudo}-connect`"
                            class="status disconnected"
                            v-bind:class="{ connected: collab.isConnected }"
                          ></div>
                          <b-avatar
                            :style="{ 'background-color': collab.color }"
                            size="35"
                            class="white--text"
                          >
                            {{ collab.initials }}
                          </b-avatar>
                          {{ collab.pseudo }}
                          <span id="role">({{ collab.role }})</span>
                          <b-dropdown
                            v-if="collab.role !== 'owner'"
                            no-caret
                            toggle-class="text-decoration-none"
                            variant="link"
                            size="sm"
                          >
                            <template #button-content>
                              <b-icon-three-dots-vertical></b-icon-three-dots-vertical>
                            </template>
                            <b-dropdown-item
                              v-if="
                                (userRole == 'admin' || userRole == 'owner') &&
                                collab.pseudo != username &&
                                collab.origin === 'collab'
                              "
                              @click="deleteUser(collab.id, collab.pseudo)"
                            >
                              Exclude from project
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="
                                collab.pseudo === username &&
                                collab.origin === 'collab'
                              "
                              @click="
                                leaveProject(collab.id, collab.pseudo, idx)
                              "
                            >
                              Leave the project
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="
                                userRole === 'admin' || userRole === 'owner'
                              "
                              @click="
                                updateValues(collab.pseudo, collab.role, idx)
                              "
                            >
                              Change role
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </li>
                    </ul>
                  </div>
                </b-tab>
                <b-tab title="Teams">
                  <div class="teams">
                    <b-button
                      v-if="userRole === 'admin' || userRole === 'owner'"
                      v-b-modal.modal-add-team
                      variant="msstreamblue"
                    >
                      Add a team
                      <b-icon icon="plus-circle"></b-icon>
                    </b-button>
                    <ul class="pa-0">
                      <li
                        v-for="(team, index) in teamsProject"
                        :key="team.uuid"
                      >
                        {{ team.teamName }}
                        <b-button
                          size="sm"
                          variant="msstreplayeramblue"
                          @click="teamSelected = team"
                          v-b-modal.modal-see-team
                          ><b-icon icon="eye-fill"></b-icon
                        ></b-button>
                        <b-button
                          size="sm"
                          variant="quanteec"
                          @click="removeTeam(index)"
                          v-b-modal.modal-delete-team
                          ><b-icon icon="trash-fill"></b-icon
                        ></b-button>
                      </li>
                    </ul>
                  </div>
                </b-tab>
                <b-tab title="Chat">
                  <div style="text-align: right">
                    <b-btn @click="popupWindow(index)">
                      <font-awesome-icon
                        icon="external-link-alt"
                      ></font-awesome-icon>
                    </b-btn>
                  </div>
                  <VireedChatProject></VireedChatProject>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </b-col>
-->
      </b-row>
    </div>

    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Submit Your Name"
      @show="loadModalCollab"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Username"
          :invalid-feedback="feedbackCollab"
          :state="collabNameState"
        >
          <b-form-input
            id="name-input"
            v-model="collabMail"
            :state="collabNameState"
            required
            list="usersList"
            autocomplete="off"
          ></b-form-input>
          <b-form-datalist
            id="usersList"
            :options="usersList"
          ></b-form-datalist>
        </b-form-group>
        <b-form-group
          label="Role"
          invalid-feedback="Role is required"
          :state="collabRoleState"
        >
          <b-form-select
            id="role-input"
            v-model="collabRole"
            :options="roles"
            state:collabRoleState
            required
          >
          </b-form-select>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      id="modal-username"
      ref="modal-username"
      :title="name+': collaborator info'"
      @ok="resetModal"
      @show="resetModal"
      @hidden="resetModal"
      hide-footer
    >
      <b-card border-variant="msstream" no-body>
        <b-card-header
          header-bg-variant="gray"
          header-text-variant="white"
          class="text-center"
        >
            <div style="text-align:center; margin-left:auto; margin-right:auto; left:0px; right:40px"
              :id="`${userSelected.pseudo}-connect`"
              class="status disconnected"
              v-bind:class="{ connected: userSelected.isConnected }"
            ></div>

          <b-avatar
            badge-variant="transparent"
            badge-offset="-2px"
            :style="{ 'background-color': userSelected.color }"
            size="35"
            class="white--text mr-3"
          >
            <template #badge>
              <font-awesome-icon
                v-if="userSelected.role === 'viewer'"
                :icon="['fas', 'eye']"
                style="color: black"
              />
              <font-awesome-icon
                v-if="userSelected.role === 'editor'"
                :icon="['fas', 'edit']"
                style="color: black"
              />
              <font-awesome-icon
                v-if="userSelected.role === 'admin'"
                :icon="['fas', 'cog']"
                style="color: black"
              />
              <font-awesome-icon
                v-if="userSelected.role === 'owner'"
                :icon="['fas', 'cog']"
                style="color: #ba0000"
              />
            </template>
            {{ userSelected.initials }}
          </b-avatar>
        </b-card-header>

        <b-table-simple stacked>
          <b-tbody>
            <b-tr >
              <b-td stacked-heading="Name">
                {{ userSelected.pseudo }}
              </b-td>

              <b-td stacked-heading="Email">
                <div class="pointerElt" style="padding: 0px; margin: 0px">
                  {{ userSelected.email }}
                  <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                </div>
              </b-td>

              <b-td v-if="userSelected.isConnected" stacked-heading="Status">
                connected &nbsp;
                <span
                  :id="`${userSelected.pseudo}-connect`"
                  class="status disconnected"
                  v-bind:class="{ connected: userSelected.isConnected }"
                ></span>
              </b-td>

              <b-td v-if="!userSelected.isConnected" stacked-heading="Status">
                disconnected &nbsp;
                <span
                  :id="`${userSelected.pseudo}-connect`"
                  class="status disconnected"
                  v-bind:class="{ connected: userSelected.isConnected }"
                ></span>
              </b-td>

              <b-td stacked-heading="Role" class="d-flex align-items-center">
                <div v-if="userSelected.role !== 'owner'">
                  <div
                    v-if="userRole === 'admin' || userRole === 'owner'"
                  >
                    <b-form-select 
                    v-model="userSelected.role"
                    :options="roles"
                    style="width:100px"
                    @change="
                      collabMail = userSelected.pseudo;
                      collabRole = userSelected.role;
                      changeRole();
                      "
                    >
                    </b-form-select>&nbsp;

                    <font-awesome-icon 
                      v-if="userSelected.role === 'viewer'"
                      :icon="['fas', 'eye']"
                    />
                    <font-awesome-icon
                      v-if="userSelected.role === 'editor'"
                      :icon="['fas', 'edit']"
                    />
                    <font-awesome-icon
                      v-if="userSelected.role === 'admin'"
                      :icon="['fas', 'cog']"
                    />
                    <span v-if="userSelected.origin === 'team'">*</span>
                  </div>
                  <div
                    v-else
                    title="You must have admin privileges to modify role"
                  >
                    {{ userSelected.role }} &nbsp;
                    <font-awesome-icon
                      v-if="userSelected.role === 'viewer'"
                      :icon="['fas', 'eye']"
                    />
                    <font-awesome-icon
                      v-if="userSelected.role === 'editor'"
                      :icon="['fas', 'edit']"
                    />
                    <font-awesome-icon
                      v-if="userSelected.role === 'admin'"
                      :icon="['fas', 'cog']"
                    />
                  </div>
                </div>
                <div
                  v-else
                  style="color: #ba0000"
                  title="The owner role cannot be changed"
                >
                  {{ userSelected.role }} 
                  <font-awesome-icon :icon="['fas', 'cog']" />
                </div>
              </b-td>

              <b-td v-if="statusVideo==='encoded'" stacked-heading="Annotations">
                <font-awesome-icon
                  :icon="['fas', 'highlighter']"
                  transform="flip-h shrink-2"
                  title="Annotations"
                />
                {{ this.AnnotNumber[userSelected.pseudo].annotations }}
                &nbsp;&nbsp;
                <small>
                  <font-awesome-layers style="margin-right:3px" title="Annotations with comments">
                    <font-awesome-icon
                      :icon="['fas', 'highlighter']"
                      transform="flip-h shrink-3 left-5"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'comment-dots']"
                      transform="shrink-3 up-5 right-4"
                    /> 
                  </font-awesome-layers>
                </small>
                {{ this.AnnotNumber[userSelected.pseudo].annotationsWithComment }}
                &nbsp;&nbsp;
                <font-awesome-icon style="margin-right:5px"
                  :icon="['fas', 'comment-dots']"
                  title="Comments"
                />{{ this.AnnotNumber[userSelected.pseudo].comments }}
              </b-td>

              <b-td v-else stacked-heading="Annotations">
                <font-awesome-icon
                  :icon="['fas', 'highlighter']"
                  transform="flip-h shrink-2"
                  title="Annotations"
                />0
                &nbsp;&nbsp;
                <small
                  ><font-awesome-layers title="Annotations with comments">
                    <font-awesome-icon
                      :icon="['fas', 'highlighter']"
                      transform="flip-h shrink-3 left-5"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'comment-dots']"
                      transform="shrink-3 up-5 right-4"
                    /> </font-awesome-layers></small
                >0
                &nbsp;&nbsp;
                <font-awesome-icon
                  :icon="['fas', 'comment-dots']"
                  title="Comments"
                />0
                &nbsp;
              </b-td>

              <b-td
                v-if="userSelected.origin === 'team'"
                stacked-heading="From Team(s)"
              >
                <ul style="list-style-type: none; padding: 0px">
                  <li
                    style="margin-bottom: 5px"
                    v-for="(team, index) in userSelected.teams"
                    :key="`team-${index}`"
                  >
                    <b-row
                      class="justify-content-between"
                      style="padding: 0px 13px"
                    >
                      <b-col cols="10"
                        class="pointerElt div200"
                        style="padding: 0px; margin: 0px"
                        @click="selectTeam(team)"
                        v-b-modal.modal-see-team
                        title="See team details"
                      >
                        {{ team }}
                      </b-col>
                      <b-col cols="1"
                        class="pointerElt"
                        style="padding: 0px; margin: 0px"
                        @click="selectTeam(team)"
                        v-b-modal.modal-see-team
                        title="See team details"
                      >
                        <font-awesome-icon :icon="['fas', 'info-circle']" />
                      </b-col>
<!--
                      <font-awesome-icon
                        v-if="userRole === 'admin' || userRole === 'owner'"
                        class="pointerEltSB"
                        style="color: red; cursor: pointer"
                        :icon="['fas', 'trash']"
                        @click="removeTeam(index)"
                        v-b-modal.modal-delete-team
                        title="Delete Team"
                      />
                      -->
                    </b-row>
                  </li>
                </ul>
              </b-td>
              <b-td v-else stacked-heading="From Team(s)">
                Not from a team in this project
              </b-td>
              <p @click="$router.push('/profil')" class="pointerEltSB" v-if="userSelected.origin === 'team' && userSelected.role !== 'owner' && (userRole === 'admin' || userRole === 'owner')" style="font-size:11px; margin:0px 8px">*Changing the role here will be applied only on this project. To change the permanent role on a Team, go to 'Team Management' on Profile page - only available to the <strong>Manager</strong> of the Team.</p>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

      <b-row class="justify-content-around">
        <b-button
          v-if="userSelected.pseudo !== username"
          class="div200"
          variant="darkblue"
          @click="openChatUser()"
        >
          <font-awesome-icon :icon="['fas', 'comments']" /> 
          Chat w/ {{ userSelected.pseudo }}
        </b-button>

        <div
          v-if="
            (userRole === 'admin' || userRole === 'owner') &&
            userSelected.role !== 'owner' &&
            userSelected.pseudo !== username &&
            userSelected.origin !== 'team'
          "
        >
          <b-button
            @click="deleteUser(userSelected.id, userSelected.pseudo)"
            variant="darkblue"
            class="div200"
            :title="'Exclude ' + userSelected.pseudo + ' from project ' + name"
          >
            <font-awesome-icon
              style="color: red"
              :icon="['fas', 'sign-out-alt']"
            />&nbsp;
            <span style="color: red">Exclude {{ userSelected.pseudo }}</span>
          </b-button>
          <!--            
            <b-button variant="darkblue" class="div200" title="Redirection to users/teams management page">
              <font-awesome-icon :icon="['fas', 'users']" />&nbsp
              <span style="">Manage</span>
            </b-button>
-->
        </div>

        <div
          v-if="
            userSelected.pseudo === username &&
            userSelected.role !== 'owner' &&
            userSelected.origin !== 'team'
          "
        >
          <b-button
            @click="leaveProject(userSelected.id, userSelected.pseudo, idx)"
            variant="darkblue"
            class="div200"
            :title="'Leave project ' + name"
          >
            <font-awesome-icon
              style="color: red"
              :icon="['fas', 'sign-out-alt']"
            />&nbsp;
            <span style="color: red">Leave project</span>
          </b-button>
          <!--
            <b-button variant="darkblue" class="div200" title="Redirection to users/teams management page">
              <font-awesome-icon :icon="['fas', 'user']" />&nbsp
              <span style="">Manage</span>
            </b-button>
-->
        </div>

        <div
          v-if="
            userSelected.pseudo === username &&
            userSelected.role !== 'owner' &&
            userSelected.origin === 'team'
          "
        >
          <b-button
            variant="lightgrey"
            class="div200"
            :title="'To leave project ' + name + ': manage your team(s)'"
          >
            <font-awesome-icon
              style="color: red"
              :icon="['fas', 'sign-out-alt']"
            />&nbsp;
            <span style="color: red">Leave project</span>
          </b-button>
          <!--
            <b-button variant="darkblue" class="div200" title="Redirection to users/teams management page">
              <font-awesome-icon :icon="['fas', 'user']" />&nbsp
              <span style="">Manage</span>
            </b-button>
-->
        </div>

        <div
          v-if="
            (userRole === 'admin' || userRole === 'owner') &&
            userSelected.role !== 'owner' &&
            userSelected.pseudo !== username &&
            userSelected.origin === 'team'
          "
        >
          <b-button
            variant="lightgrey"
            class="div200"
            :title="
              'To exclude ' +
              userSelected.pseudo +
              ' from project ' +
              name +
              ': manage the team(s)'
            "
          >
            <font-awesome-icon
              style="color: red"
              :icon="['fas', 'sign-out-alt']"
            />&nbsp;
            <span style="color: red">Exclude {{ userSelected.pseudo }}</span>
          </b-button>
          <!--
            <b-button variant="darkblue" class="div200" title="Redirection to users/teams management page">
              <font-awesome-icon :icon="['fas', 'users']" />&nbsp
              <span style="">Manage</span>
            </b-button>
-->
        </div>
      </b-row>
      <div
        v-if="
          userRole !== 'admin' &&
          userRole !== 'owner' &&
          userSelected.role !== 'owner' &&
          userSelected.pseudo !== username
        "
      >
        <small>*Contact an administrator to modify this collaborator</small>
      </div>

      <!--
        {{userSelected.pseudo}}
        <div v-if="userSelected.isConnected">Status: connected &nbsp
        <span
        :id="`${userSelected.pseudo}-connect`"
        class="status disconnected"
        v-bind:class="{connected:userSelected.isConnected}"
        ></span>
        </div>

        <div v-else> Status: disconnected &nbsp</div>


        <div v-if="userSelected.role === 'viewer'">Role: viewer
        </div>
          <font-awesome-icon v-if="userSelected.role === 'viewer' " :icon="['fas', 'eye']" style="color:black; " transform="" />
        <div v-if="userSelected.role === 'editor'">Role: editor
          <font-awesome-icon v-if="userSelected.role === 'editor' " :icon="['fas', 'edit']" style="color:black;" transform="" />
        </div>
        <div v-if="userSelected.role === 'admin'">Role: admin
          <font-awesome-icon v-if="userSelected.role === 'admin' " :icon="['fas', 'cog']" style="color:black; " transform="" />
        </div>
        <div v-if="userSelected.role === 'owner'">Role: <span style="color:#ba0000"> owner </span>
            <font-awesome-icon v-if="userSelected.role === 'owner' " :icon="['fas', 'cog']" style="color:#ba0000; " transform="" />
        </div> 
      </b-card>

      <b-card border-variant="msstream" no-body>
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h5>Team information</h5>
        </b-card-header>
        <b-table-simple stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Team name">{{teamSelected.teamName}}</b-td>
              <b-td stacked-heading="Team Description">{{teamSelected.teamDescription}}</b-td>
              <b-td stacked-heading="Owner">{{teamSelected.ownerTeam}}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
      <b-card border-variant="msstream" no-body style="margin-top:20px">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h4>Members</h4>
        </b-card-header>
        <b-table show-empty centered responsive striped bordered :items="teamSelected.collabsTeam">
        </b-table>
     </b-card>
-->
    </b-modal>

    <b-modal
      id="modal-see-users"
      ref="modal-see-users"
      :title="name +': collaborators'"
      @ok="resetModal"
      @show="loadModalCollab"
      @hidden="resetModal"
      hide-footer
    >
      <b-row
        class="align-items-center h-100 justify-content-center"
        style="
          padding: 10px;
          margin: 1px;
          background-color: #113448;
          border-radius: 5px;
          color: white;
        "
      >
        <h5 class="p-0 m-0">
          <font-awesome-icon :icon="['fas', 'user-tie']" />&nbsp;
          Collaborators
          <b-badge title="Number of collaborators in the project">{{collabsList.length}}</b-badge>
        </h5>
      </b-row>

      <b-row class="align-items-center h-100">
        
        <b-table
          ref="tableCollabModal"
          :items="collabsList"
          :fields="collabsTable"
          show-empty
          small
          style="margin:10px 20px; font-size:small; text-align:center"
        >
          <template #cell(icon)="data">
            <div
              :id="`${data.item.pseudo}-connect`"
              class="status disconnected"
              v-bind:class="{ connected: data.item.isConnected }"
            ></div>
            <b-avatar
              badge-variant="transparent"
              badge-offset="-2px"
              :style="{ 'background-color': data.item.color }"
              size="35"
              class="white--text"
              button
              @click="userSelected = data.item"
              v-b-modal.modal-username
              title="Click to show all info on the Collaborator"
            >
              <template #badge>
                <font-awesome-icon
                  v-if="data.item.role === 'viewer'"
                  :icon="['fas', 'eye']"
                  style="color: black"
                />
                <font-awesome-icon
                  v-if="data.item.role === 'editor'"
                  :icon="['fas', 'edit']"
                  style="color: black"
                />
                <font-awesome-icon
                  v-if="data.item.role === 'admin'"
                  :icon="['fas', 'cog']"
                  style="color: black"
                />
                <font-awesome-icon
                  v-if="data.item.role === 'owner'"
                  :icon="['fas', 'cog']"
                  style="color: #ba0000"
                />
              </template>
              {{ data.item.initials }}
            </b-avatar>
          </template>

          <template #cell(pseudo)="data">
              <div class="divName2" style="text-align:left" :title="'Collaborator name: '+data.item.pseudo">
                {{data.item.pseudo}}
              </div>
          </template>

          <template #cell(role)="data">
            <div 
              v-if="
                data.item.pseudo != owner &&
                (userRole === 'admin' || userRole === 'owner')
              "
              style="min-width:100px"
            >
              <b-form-select 
                v-model="data.item.role"
                :options="roles"
                style="font-size:small"
                class="w-75"
                @change="
                  collabMail = data.item.pseudo;
                  collabRole = data.item.role;
                  changeRole();
                "
              >
              </b-form-select>
              <span style="margin-left:1px" v-if="data.item.origin === 'team'" v-on="fromTeamOn()">&#134;</span>
            </div>
            <div v-else-if="data.item.role === 'owner'" style="color: #ba0000">
              {{ data.item.role }}
            </div>            
            <div v-else>
              {{ data.item.role }}
            </div>                        
          </template>

          <template #cell(annots)="data">
            <div v-if="statusVideo === 'encoded'">
            <font-awesome-icon
              :icon="['fas', 'highlighter']"
              transform="flip-h shrink-2"
              title="Number of annotations made by the Collaborator"
            />
            {{ AnnotNumber[data.item.pseudo].annotations }}
            &nbsp;&nbsp;
            <font-awesome-layers title="Number of annotations w/ comments made by the Collaborator">
              <font-awesome-icon
              :icon="['fas', 'highlighter']"
              transform="flip-h shrink-3 left-5"
              />
              <font-awesome-icon
              :icon="['fas', 'comment-dots']"
              transform="shrink-3 up-5 right-4"
              /> 
            </font-awesome-layers>
            {{ AnnotNumber[data.item.pseudo].annotationsWithComment }}
            &nbsp;&nbsp;
            <font-awesome-icon
              :icon="['fas', 'comment-dots']"
              title="Number of comments made by the Collaborator"
            />&nbsp;{{ AnnotNumber[data.item.pseudo].comments }}
            </div>
          </template>

          <template #cell(exclude)="data">
            
            <div
              v-if="
                (userRole === 'admin' || userRole === 'owner') &&
                data.item.role !== 'owner' &&
                data.item.pseudo !== username &&
                data.item.origin !== 'team'
              "
            >
                <font-awesome-icon
                  style="color: red"
                  class="pointerEltSB"
                  :icon="['fas', 'sign-out-alt']"
                  @click="deleteUser(data.item.id, data.item.pseudo)"
                  :title="'Exclude ' + data.item.pseudo + ' from project ' + name"
                />
            </div>
            <div v-else-if="data.item.origin === 'team'" >
              <div class="pointerEltSB" v-if="data.item.teams.length === 1" v-b-modal.modal-see-teams :title="'From Team: '+data.item.teams[0]+'. To exclude ' + data.item.pseudo + ', exclude Team: '+data.item.teams[0]+' from the project'" v-b>
                <font-awesome-icon :icon="['fas', 'user-friends']" />
                <small><strong>{{ data.item.teams.length }}</strong></small>
              </div>
              <div v-else class="pointerEltSB" v-b-modal.modal-see-teams :title="'From '+data.item.teams.length+' teams ('+data.item.teams[0]+' and others). To exclude ' + data.item.pseudo + ', exclude his Teams from the project'" v-b>
                <font-awesome-icon :icon="['fas', 'user-friends']" />
                <small><strong>{{ data.item.teams.length }}</strong></small>
              </div>
            </div>

          </template>
        </b-table>
        <div @click="$router.push('/profil')" class="pointerEltSB" v-if="fromTeam && (userRole === 'admin' || userRole === 'owner')" style="font-size:10px; margin:0px 10px 10px 10px">&#134;Changing the role here will be applied only on this project. To change the permanent role on a Team, go to 'Team Management' on Profile page - only available to the <strong>Manager</strong> of the Team.</div>
      </b-row>

      <b-row
        class="align-items-center h-100 justify-content-center"
        style="
          padding: 10px;
          margin: 1px;
          background-color: #113448;
          border-radius: 5px;
          color: white;
        "
        v-if="userRole === 'owner' || userRole === 'admin'"
      >
        <h6 class="p-0 m-0">
          <b-icon icon="plus-circle" />&nbsp;
          add collaborators* 
          <b-badge title="Number of collaborators that can be added to the project">{{usersListObject.length}}</b-badge>
        </h6>
      </b-row>

      <b-row class="align-items-center h-100" v-if="userRole === 'owner' || userRole === 'admin'">
        <b-table
          ref="tableCollabModal"
          :items="usersListObject"
          :fields="usersTable"
          show-empty
          small
          style="margin:10px 20px; text-align:center; font-size:small"
        >
          <template #cell(icon)="data">
            <!--
            <div
              :id="`${data.item.pseudo}-connect`"
              class="status disconnected"
              v-bind:class="{ connected: data.item.isConnected }"
            ></div>
            -->
            <b-avatar
              badge-variant="transparent"
              badge-offset="-2px"
              :style="{ 'background-color': data.item.color }"
              size="35"
              class="white--text"
              button
              title="Click to show all info on the Collaborator"
            >
            
              <template #badge>
                <font-awesome-icon
                  v-if="data.item.role === 'viewer'"
                  :icon="['fas', 'eye']"
                  style="color: black"
                />
                <font-awesome-icon
                  v-if="data.item.role === 'editor'"
                  :icon="['fas', 'edit']"
                  style="color: black"
                />
                <font-awesome-icon
                  v-if="data.item.role === 'admin'"
                  :icon="['fas', 'cog']"
                  style="color: black"
                />
                <font-awesome-icon
                  v-if="data.item.role === 'owner'"
                  :icon="['fas', 'cog']"
                  style="color: #ba0000"
                />
              </template>
              {{ data.item.initials }}
            </b-avatar>
          </template>

          <template #cell(pseudo)="data">
            <div class="divName2" style="text-align:left" :title="'Collaborator name: '+data.item.pseudo">
              {{data.item.pseudo}}
            </div>
          </template>

          <template #cell(role)="data">
            <div 
              v-if="
                data.item.pseudo != owner &&
                (userRole === 'admin' || userRole === 'owner')
              "
            >
              <b-form-select 
              v-model="data.item.role" 
              :options="roles"
              style="font-size:small"
              >
              </b-form-select>
            </div>
            <div v-else>
              {{ data.item.role }}
            </div>
          </template>

          <template #cell(include)="data">
            
            <b-button
              v-if="
                (userRole === 'admin' || userRole === 'owner') &&
                data.item.role !== 'owner' &&
                data.item.pseudo !== username &&
                data.item.origin !== 'team'
              "
              @click="collabMail = data.item.pseudo;
              collabRole = data.item.role;
              addCollab(data.item.id, data.item.pseudo);
              "
              :title="'Add ' + data.item.pseudo + ' to project ' + name"
              variant="msstreamblue"
              style="padding:2px 10px"
            >
            <small>
              Add
              <font-awesome-icon
                :icon="['fas', 'sign-in-alt']"
              />
            </small>
            </b-button>
          </template>
        </b-table>
      </b-row>
      <div v-if="userRole === 'owner' || userRole === 'admin'" @click="$router.push('/profil')" class="pointerEltSB" style="font-size:10px">*From <strong>Users</strong> list. Go to the 'Manage Users' section on your Profile for any other action on users - only available to <strong>Account Managers</strong>.</div>
    </b-modal>

    <b-modal
      id="modal-see-teams"
      ref="modal-see-teams"
      :title="name+': teams'"
      @show="getTeams"
      hide-footer
    >
      <b-row
        class="align-items-center h-100 justify-content-center"
        style="
          padding: 10px;
          margin: 1px;
          background-color: #113448;
          border-radius: 5px;
          color: white;
        "
      >
        <h5 class="p-0 m-0">
          <font-awesome-icon :icon="['fas', 'user-friends']" />
          Teams
          <b-badge title="Number of teams in the project">{{teamsProject.length}}</b-badge>
        </h5>
      </b-row>

      <b-row class="align-items-center h-100">
        <b-table
          ref="tableTeamProjectModal"
          :items="teamsProject"
          :fields="projectTeamsTable"
          show-empty
          small
          style="margin:10px 20px 30px; text-align:center; font-size:small"
        >
          <template v-slot:cell(teamname)="row">
            <b-row class="justify-content-center align-items-center pointerEltSB" style="margin:1px 3px" :title="'Team name: '+row.item.teamName" @click="teamSelected = row.item" v-b-modal.modal-see-team>
              <div class="divBreak" style="text-align:justify"> {{ row.item.teamName }} </div>&nbsp;
              <font-awesome-icon :icon="['fas', 'info-circle']" />
            </b-row>
          </template>

          <template v-slot:cell(descriptionTeam)="row">
            <b-row class="justify-content-center align-items-center pointerEltSB" style="margin:1px 3px" :title="'Description: '+row.item.teamDescription" @click="teamSelected = row.item" v-b-modal.modal-see-team>
              <div class="divBreak" style="text-align:justify"> {{ row.item.teamDescription }}</div>
            </b-row>
          </template>

          <template v-slot:cell(manager)="row">
            <b-row class="justify-content-center align-items-center" style="margin:1px 3px" :title="'Manager of the team: '+row.item.ownerTeam">
              <div class="divName3" style="color:#2F90B0"> {{ row.item.ownerTeam }}</div>
            </b-row>
          </template>

          <template v-slot:cell(members)="row">
            <div v-for="(collab, idx) in row.item.collabsTeam" :key="idx"> 
              <b-row class="justify-content-center align-items-center" style="margin:1px 3px; min-width:100px">
              <div class="divName3">{{ collab.username }}</div>
              <small>
              <font-awesome-icon
              v-if="collab.role === 'viewer'"
              :icon="['fas', 'eye']"
              style="color: black"
              />
              <font-awesome-icon
              v-if="collab.role === 'editor'"
              :icon="['fas', 'edit']"
              style="color: black"
              />
              <font-awesome-icon
              v-if="collab.role === 'admin'"
              :icon="['fas', 'cog']"
              style="color: black"
              />
              <font-awesome-icon
              v-if="collab.role === 'owner'"
              :icon="['fas', 'cog']"
              style="color: #ba0000"
              />
              </small>
              </b-row>
            </div>
          </template>

          <template v-slot:cell(exclude)="row">
            <div style="max-width:20px" v-if="userRole === 'admin' || userRole === 'owner'">
              <font-awesome-icon
              style="color: red"
              class="pointerEltSB"
              :icon="['fas', 'sign-out-alt']"
              @click="removeTeam(row.item)"
              :title="'Exclude team ' + row.item.teamName + ' from project ' + name"
              />
            </div>
          </template>
        </b-table>
      </b-row>

      <b-row
        class="align-items-center h-100 justify-content-center"
        style="
          padding: 10px;
          margin: 1px;
          background-color: #113448;
          border-radius: 5px;
          color: white;
        "
        v-if="userRole === 'owner' || userRole === 'admin'"
      >
        <h6 class="p-0 m-0">
          <b-icon icon="plus-circle" />&nbsp;
          add teams* 
          <b-badge title="Number of teams that can be added to the project">{{teamsUser.length}}</b-badge>
        </h6>
      </b-row>

      <b-row class="align-items-center h-100 justify-content-center" v-if="userRole === 'owner' || userRole === 'admin'">
        <b-table
          ref="tableTeamUserModal"
          :items="teamsUser"
          :fields="teamsTable"
          show-empty
          small
          style="margin:10px 20px; text-align:center; font-size:small"
        >
          <template v-slot:cell(teamname)="row">
            <b-row class="justify-content-center align-items-center pointerEltSB" style="margin:1px 3px" :title="'Team name: '+row.item.teamName" @click="teamSelected = row.item" v-b-modal.modal-see-team>
              <div class="divBreak" style="text-align:justify"> {{ row.item.teamName }} </div>&nbsp;
              <font-awesome-icon :icon="['fas', 'info-circle']" /> 
            </b-row>
          </template>

          <template v-slot:cell(descriptionTeam)="row">
            <b-row class="justify-content-center align-items-center pointerEltSB" style="margin:1px 3px" :title="'Description: '+row.item.teamDescription" @click="teamSelected = row.item" v-b-modal.modal-see-team>
              <div class="divBreak" style="text-align:justify">{{ row.item.teamDescription }}</div>
            </b-row>
          </template>

          <template v-slot:cell(manager)="row">
            <b-row class="justify-content-center align-items-center" style="margin:1px 3px" :title="'Manager of the team: '+row.item.ownerTeam">
              <div class="divName3" style="color:#2F90B0">{{ row.item.ownerTeam }}</div>
            </b-row>
          </template>

          <template v-slot:cell(members)="row">
            <div v-for="(collab, idx) in row.item.collabsTeam" :key="idx"> 
              <b-row class="justify-content-center align-items-center" style="margin:1px 3px; min-width:100px">
              <div class="divName3">{{ collab.username }}</div>
              <small>
              <font-awesome-icon
              v-if="collab.role === 'viewer'"
              :icon="['fas', 'eye']"
              style="color: black"
              />
              <font-awesome-icon
              v-if="collab.role === 'editor'"
              :icon="['fas', 'edit']"
              style="color: black"
              />
              <font-awesome-icon
              v-if="collab.role === 'admin'"
              :icon="['fas', 'cog']"
              style="color: black"
              />
              <font-awesome-icon
              v-if="collab.role === 'owner'"
              :icon="['fas', 'cog']"
              style="color: #ba0000"
              />
              </small>
              </b-row>
            </div>
          </template>


          <template v-slot:cell(addteam)="row">
            <b-button
            v-if="userRole === 'admin' || userRole === 'owner'"
            @click="addTeam(row.item)"
            :title="'Add team ' + row.item.teamName + ' to project ' + name"
            variant="msstreamblue"
            style="padding:2px 6px; min-width:60px"
            >
              <small>
                Add
                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
              </small>
            </b-button>
          </template>
        </b-table>
      </b-row>
      <div v-if="userRole === 'owner' || userRole === 'admin'" @click="$router.push('/profil')" class="pointerEltSB" style="font-size:10px">*From <strong>Teams</strong> list. Go to the 'Manage Teams' section on your Profile for any other action on Teams - only available to the <strong>Manager</strong> of the team.</div>
    </b-modal>

    <b-modal
      id="modal-see-team"
      ref="modal-see-team"
      :title="name+': Team info'"
      @ok="resetModal"
      @show="resetModal"
      @hidden="resetModal"
      hide-footer
    >
      <b-card border-variant="msstream" no-body>
        <b-card-header
          header-bg-variant="gray"
          header-text-variant="#2a5d77"
          class="text-center"
        >
          <h5 style="margin:0px">
            {{teamSelected.teamName}}
            <b-badge v-if="teamSelected.collabsTeam !== undefined" title="Number of members in the team">{{teamSelected.collabsTeam.length}}</b-badge>
          </h5>
        </b-card-header>
        <b-table-simple stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Team Description">{{
                teamSelected.teamDescription
              }}</b-td>
              <b-td stacked-heading="Team Manager"><span style="color:#2F90B0"> {{ teamSelected.ownerTeam }}</span>
              </b-td>
              <b-td stacked-heading="Members w/ roles* in projects">
                <div v-for="(collab, idx) in teamSelected.collabsTeam" :key="idx"> 
                  <b-row class="align-items-center">
                    <b-col cols="8" style="padding:0px 0px 10px 15px">
                    {{ collab.username }}:
                    </b-col>
                    <b-col cols="4" style="padding:0px 0px 10px 10px">
                      {{ collab.role }}
                      <small>
                        <font-awesome-icon
                        v-if="collab.role === 'viewer'"
                        :icon="['fas', 'eye']"
                        style="color: black"
                        />
                        <font-awesome-icon
                        v-if="collab.role === 'editor'"
                        :icon="['fas', 'edit']"
                        style="color: black"
                        />
                        <font-awesome-icon
                        v-if="collab.role === 'admin'"
                        :icon="['fas', 'cog']"
                        style="color: black"
                        />
                        <font-awesome-icon
                        v-if="collab.role === 'owner'"
                        :icon="['fas', 'cog']"
                        style="color: #ba0000"
                        />
                      </small>
                    </b-col>
                  </b-row>
                </div>
              </b-td>
              <div @click="$router.push('/profil')" class="pointerEltSB" style="font-size:10px; margin:8px">*Those roles are the ones configured in the 'Teams List'. Go to the 'Manage Teams' section on your Profile for any action on Teams - only available to the <strong>Manager</strong> of the team.</div>
              <div style="font-size:10px; margin:8px">Changing the role of a collaborator for the project can be done on the Collaborator panel - only available to the <strong>Admins</strong> of the project.</div>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

      <b-row class="justify-content-around">
        <b-button
          class="div450"
          variant="darkblue"
          @click="openChatTeam()"
        >
          <font-awesome-icon :icon="['fas', 'comments']" /> 
          Chat w/ Team: {{ teamSelected.teamName }}
        </b-button>
      </b-row>

    </b-modal>

    <b-modal
      id="modal-change-role"
      ref="modal"
      title="Change Role"
      @ok="changeRole"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Username"
          :invalid-feedback="feedbackCollab"
          :state="collabNameState"
        >
          <b-form-input
            id="name-input"
            v-model="collabMail"
            :state="collabNameState"
            required
            :disabled="true"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Role"
          invalid-feedback="Role is required"
          :state="collabRoleState"
        >
          <b-form-select
            id="role-input"
            v-model="collabRole"
            :options="roles"
            state:collabRoleState
            required
          >
          </b-form-select>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      id="modal-add-team"
      ref="modal"
      title="Add a team to this project"
      @show="getTeams()"
    >
      <b-table
        show-empty
        centered
        responsive
        striped
        bordered
        :items="teamsUser"
        :fields="teamsTable"
      >
        <template v-slot:cell(teamname)="row">
          {{ row.item.teamName }}
        </template>

        <template v-slot:cell(descriptionTeam)="row">
          {{ row.item.teamDescription }}
        </template>

        <template v-slot:cell(owner)="row">
          {{ row.item.ownerTeam }}
        </template>

        <template v-slot:cell(addteam)="row">
          <b-button variant="msstreamblue" @click="addTeam(row.item)">
            Add <b-icon icon="plus-circle"></b-icon
          ></b-button>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
let moment = require("moment");

import VireedPlayer from "@/components/VireedPlayer.vue";
import VireedChatProject from "@/components/VireedChatProject.vue";
import vireedAnnotationService from "@/services/vireedAnnotation.service.js";
import userService from "@/services/user.service.js";
import vireedSidebarProject from "@/components/VireedSidebarProject.vue";

import TeamService from "@/services/team.service.js";
import Swal from "sweetalert2";

import ProjectService from "@/services/project.service.js";
import VideoService from "@/services/video.service.js";

import { EventBus } from "@/event-bus.js";

var Pservice = new ProjectService();
var Vservice = new VideoService();
var VideoMethods = new vireedAnnotationService();
let tService = new TeamService();
var uService = new userService();

export default {
  name: "Video",
  components: {
    vireedSidebarProject,
    VireedPlayer,
    VireedChatProject,
  },
  data: function () {
    let version = "-1";
    if (this.$route.params.version) {
      version = this.$route.params.version;
    }
    return {
      lastUpdated: "",
      createdAt: "",
      collabCollapsKey: 0,
      allUsersCheck: false,
      initials: "",
      colorAvatar: "",
      hover: false,
      videoaddr: "",
      name: "",
      description: "",
      owner: "",
      projectVersion: version,
      teamsProject: [],
      teamsUser: [],
      dialog: false,
      dialog2: false,
      defaultRole: "viewer",
      roles: ["admin", "editor", "viewer"],
      videoKey: version,
      collabsKey: 0,
      dialogRole: false,
      post: {
        playerOptions: {
          autoplay: true,
          controls: true,
          controlBar: {
            // inline volume to prevent timeline width change
            volumePanel: { inline: false },
            pictureInPictureToggle: false,
            currentTime: true,
          },
        },
      },
      collabsList: [],
      selected: [],
      fromTeam: false,
      expand: 0,
      expandBar: true,
      timeStyleLeft: 173,
      collabMail: "",
      collabRole: "",
      callNumber: 0,
      callNumberAdjust: 0,
      userRole: "",
      username: "",
      roleChanged: false,
      videoPlayerKey: 1,
      collaboratorsListKey: 1,
      collabNameState: null,
      collabRoleState: null,
      nameState: null,
      currentCollabIdx: null,
      annotOn: false,
      collapseOn: false,

      feedbackCollab: "Username is required",
      teamsTable: [
        { key: "teamname", label: "Name", tdClass: 'align-middle' },
        { key: "descriptionTeam", label: "Description", tdClass: 'align-middle' },
        { key: "manager", label: "Manager", tdClass: 'align-middle' },
        { key: "members", label: "Members", tdClass: 'align-middle' },
        { key: "addteam", label: "", tdClass: 'align-middle' },
      ],
      projectTeamsTable: [
        { key: "teamname", label: "Name", tdClass: 'align-middle' },
        { key: "descriptionTeam", label: "Description", tdClass: 'align-middle' },
        { key: "manager", label: "Manager", tdClass: 'align-middle' },
        { key: "members", label: "Members", tdClass: 'align-middle' },
        { key: "exclude", label: "", tdClass: 'align-middle' },
      ],
      collabsTable: [
        { key: "icon", label: "", thClass: 'text-left', tdClass: 'text-left' },
        { key: "pseudo", label: "Name", sortable: true, thClass: 'text-left', tdClass: 'align-middle' },
        { key: "role", label: "Role", sortable: true, tdClass: 'align-middle' },
        { key: "annots", label: "Annotations", tdClass: 'align-middle' },
        { key: "exclude", label: "", tdClass: 'align-middle' },
      ],
      usersTable: [
        { key: "icon", label: "", tdClass: 'text-left' },
        { key: "pseudo", label: "Name", sortable: true, thClass: 'text-left', tdClass: 'align-middle' },
        { key: "role", label: "Role", sortable: true, tdClass: 'align-middle' },
        { key: "include", label: "", tdClass: 'align-middle' },
      ],
      teamSelected: "",
      userSelected: { pseudo: "bobby" },
      sideBarKey: 1,
      usersList: [],
      noVideo: false,
      statusVideo: "",
      uuidVideoVersion: "",
      mustRefresh: false,
      projectKey: 0,
      projectId: this.$route.params.projectId,
      AnnotNumber: {
        bobby: { annotations: 0, annotationsWithComment: 0, comments: 0 },
      },
      videoTitle: "",
      totalAnnotCount: {},
      roles: ["admin", "editor", "viewer"],
      usersListObject: [],
      teamSelectedName: "",
      updateProjectTitle: false,
      newName: "",
      updateProjectDescription: false,
      newDescription: "",
    };
  },
  methods: {
    selectTeam(teamName) {
      var idx = this.teamsProject.findIndex(
        (team) => team.teamName === teamName
      );
      this.teamSelected = this.teamsProject[idx];
    },
    openChatUser() {
      var url = "#/chat/singleConv/" + this.userSelected.pseudo;
      window.open(url, this.userSelected.pseudo, "width=1200, height=750");
    },
    openChatTeam() {
      var url = "#/chat/team/" + this.teamSelected.uuid;
      window.open(url, this.teamSelected.teamName, "width=1200, height=750");
    },
    changeAnnot() {
      this.annotOn = !this.annotOn;
    },
    removeCollapse() {
      this.collapseOn = false;
    },
    fromTeamOn() {
      this.fromTeam = true;
    },
    fromTeamOff() {
      this.fromTeam = false;
    },

    getTeams() {
      //this.teamsUser = [];

      tService.getTeams(this.$auth.token()).then((teams) => {
        for (let i = 0; i < teams.length; i++) {
          if (
            !this.teamsProject.find(
              (projTeam) => projTeam.uuid === teams[i].uuid
            )
          ) {
            if (
              !this.teamsUser.find(
                (userTeam) => userTeam.uuid === teams[i].uuid
              )
            )
              this.teamsUser.push(teams[i]);
          }
        }
      });
    },
    changeVersion: function () {

      //document.getElementById("videoPlayer").classList.add("noDisplayVideo")
      this.mustRefresh = false;

      Pservice.getProject(this.$auth.token(), this.$route.params.projectId)
        .then((project) => {
          console.log(this.$route.params.version)
          this.projectVersion = this.$route.params.version;
          let versions = project.versions;
          let currentVersion = versions.find(
            (version) => version.number == this.projectVersion
          );
          this.uuidVideoVersion = currentVersion.uuidVideo;
          this.checkEncodingPercent();

          Vservice.getVideoManifest(
            currentVersion.uuidVideo,
            this.$auth.token()
          )
            .then((video) => {
              this.noVideo = false;
              this.videoTitle = video.title;
              this.videoKey += 1;
            this.post = {
              playerOptions: {
                autoplay: true,
                controls: true,
                techOrder: ["html5"],
                sources: [
                  {
                    //src: "/v/videos/" + this.$route.params.projectId + "/" + version,
                    src: video.m3u8,
                    type: "application/x-mpegurl",
                  },
                ],
                controlBar: {
                  // inline volume to prevent timeline width change
                  volumePanel: { inline: false },
                  pictureInPictureToggle: false,
                  currentTime: true,
                },
              },
            };
            })
            .catch((err) => {
              console.error(err);
              this.noVideo = true;
              document.getElementById("videoPlayer").classList.add("noDisplayVideo")
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateValues: function (mail, role, idx) {
      this.collabMail = mail;
      this.collabRole = role;
      this.currentCollabIdx = idx;
      this.$bvModal.show("modal-change-role");
    },
    changeRole: function () {
      VideoMethods.changeRole(
        this,
        this.$auth.token(),
        this.collabMail,
        this.collabRole
      );

      // let url =
      //   "/a/project/" +
      //   this.$route.params.projectId +
      //   "/user/" +
      //   id +
      //   "?role=" +
      //   this.collabRole;
      // fetch(url, {
      //   method: "POST",
      // }).then((res) => {
      //   if (res.status === 201) {
      //     console.log("role changed");
      //     this.roleChanged = true;
      //     // this.videoPlayerKey++;
      //     this.changeVersion();
      //     this.collabsList[this.currentCollabIdx].role = this.collabRole;
      //     this.collaboratorsListKey++;
      //     // location.reload();
      //   }
      // });
    },
    deleteUser: function (id, pseudo) {
      VideoMethods.deleteUser(this.$auth.token(), pseudo, this, Swal);
    },
    updateUserList: function () {
      uService.getUsers(this.$auth.token()).then((users) => {
        this.usersListObject = [];
        this.userList = [];
        users.forEach((user) => {
          let collab = {
            role: "viewer",
            pseudo: user.username,
            origin: "collab",
            color: "#" + user.color,
            initials: (user.username[0] + user.username[1]).toUpperCase(),
            isConnected: false,
          };

          if (
            this.collabsList.findIndex(
              (user) => user.pseudo === collab.pseudo
            ) === -1
          ) {
            this.usersListObject.push(collab);
            this.usersList.push(user.username);
          }
        });
      });
    },
    leaveProject: function (id, pseudo, idx) {
      VideoMethods.leaveProject(this.$auth.token(), pseudo, this, Swal, idx);
    },
    checkboxChecked: function (user) {
      VideoMethods.reloadVisible(user, this.selected);
    },
    collapse: function () {
      this.allUsersCheck = !this.allUsersCheck;
      if (this.expandBar) this.expand = 1;
      if (!this.expandBar) this.expand = 0;
      if (this.expand === 1) {
        document.getElementsByClassName("vac-marker").forEach((marker) => {
          marker.classList.add("expanded");
        });
      } else {
        document.getElementsByClassName("vac-marker").forEach((marker) => {
          try {
            marker.classList.remove("expanded");
          } catch (ignored) {
            ("");
          }
        });
      }
    },
    addCollab: function () {
      return new Promise((done, reject) => {
        Pservice.addCollaborator(
          this.$auth.token(),
          this.$route.params.projectId,
          this.collabMail,
          this.collabRole
        )
          .then((res) => {
            var newAnnot = {
              annotations: 0,
              annotationsWithComment: 0,
              comments: 0,
            };
            this.AnnotNumber[this.collabMail] = newAnnot;
            this.$socket.emit("usersAdd");
            this.reloadProjectUser();
            var idxUser = this.usersListObject.findIndex(
              (user) => user.pseudo === this.collabMail
            );
            this.usersListObject.splice(idxUser, 1);
            done(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    adjustNumber: function () {
      if (
        this.callNumberAdjust > 1 &&
        this.callNumberAdjust <= 2 * this.collabsList.length
      ) {
        this.callNumber = this.callNumberAdjust;
        this.dialog2 = false;
      } else {
        Swal.fire({
          icon: "error",
          title: `Invalid number.`,
          showConfirmButton: true,
          confirmButtonText: `OK`,
        });
      }
    },
    call: function () {
      let id;
      let url = "/a/user";
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        res.json().then((data) => {
          id = data.pseudo;
          let url2 =
            "/c/project/" +
            this.$route.params.projectId +
            "/user/" +
            id +
            "/nbr/" +
            this.callNumber;
          fetch(url2, {
            method: "GET",
          }).then((res) => {
            console.log(res);
            let newWindow = open("/c/", "chatVideo", "width=900,height=900");
            // incrémente de 1
            newWindow.focus();
            //newWindow.onbeforeunload() => décrémente de 1
          });
        });
      });
    },
    callIndividual: function (target) {
      console.log("Individual call towards " + target + " initiated");
    },
    checkFormValidity() {
      //const valid = this.$refs.form.checkValidity()
      if (!this.collabMail) {
        this.collabNameState = false;
        this.feedbackCollab = "Username is required";
      } else this.collabNameState = true;
      if (!this.collabRole) this.collabRoleState = false;
      else this.collabRoleState = true;
      return this.collabRoleState && this.collabNameState;
    },
    resetModal() {
      this.collabMail = "";
      this.collabNameState = null;
      this.collabRole = "";
      this.collabRoleState = null;
      this.currentCollabIdx = null;
    },
    loadModalCollab() {
      this.fromTeam = false;
      this.collabMail = "";
      this.collabNameState = null;
      this.collabRole = "";
      this.collabRoleState = null;
      this.currentCollabIdx = null;
      this.usersList = [];
      this.usersListObject = [];

      uService.getUsers(this.$auth.token()).then((users) => {
        users.forEach((user) => {
          let collab = {
            role: "viewer",
            pseudo: user.username,
            origin: "collab",
            color: "#" + user.color,
            initials: (user.username[0] + user.username[1]).toUpperCase(),
            isConnected: false,
          };

          if (
            this.collabsList.findIndex(
              (user) => user.pseudo === collab.pseudo
            ) === -1
          ) {
            this.usersListObject.push(collab);
            this.usersList.push(user.username);
          }
        });
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      var response = this.addCollab()
        .then((response) => {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-prevent-closing");
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 404) {
            this.feedbackCollab = err.response.data;
            this.collabNameState = false;
          }
        });
    },
    addTeam(team) {
      Pservice.addTeam(
        this.$auth.token(),
        this.$route.params.projectId,
        team.uuid
      ).then((res) => {
        var idx = this.teamsUser.findIndex(
          (teamAdded) => teamAdded.uuid === team.uuid
        );
        this.teamsUser.splice(idx, 1);
        this.teamsProject.push(team);
        this.reloadProjectUser();
        this.$socket.emit("usersAdd");
      });
    },
    removeTeam(teamToDelete) {
      var indexTeam = this.teamsProject.findIndex(
        (team) => team.uuid === teamToDelete.uuid
      );
      var teamToRemove = this.teamsProject[indexTeam];
      Swal.fire({
        title: `Team exclusion`,
        html:
          'Please confirm the exclusion of Team "' +
          teamToRemove.teamName +
          '" out of this project',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `Exclude`,
      }).then((result) => {
        if (result.isConfirmed) {
          Pservice.removeTeam(
            this.$auth.token(),
            this.teamsProject[indexTeam].uuid,
            this.$route.params.projectId
          ).then(() => {
            this.teamsProject.splice(indexTeam, 1);
            this.$socket.emit("teamRemove");
            this.reloadProjectUserAfterTeamDeletion();
            this.getTeams();
          });
        }
      });
    },
    reloadProjectUserAfterTeamDeletion() {
      let style = document.createElement("style");
      style.id = "collabStyle";

      //On met à jour la liste des équipes
      Pservice.getProject(
        this.$auth.token(),
        this.$route.params.projectId
      ).then((project) => {
        //this.teamsProject = [];
        project.teams.forEach((team) => {
          tService
            .getTeam(this.$auth.token(), team)
            .then((team) => {
              if (
                !this.teamsProject.find(
                  (teamProj) => teamProj.uuid === team.uuid
                )
              )
                this.teamsProject.push(team);
            })
            .catch((err) => {
              console.log(err);
            });
        });
      });

      var user = this.$auth.getMyUser();
      let userPseudo = user.username;
      this.username = user.username;
      Pservice.getUsersOfProject(
        this.$auth.token(),
        this.$route.params.projectId
      )
        .then((response) => {
          //On filtre pour faire un nouveau tableau ne contenant que les "utilisateurs restants"
          //par rapport au résultat de la requête (cela retire les utilisateurs)
          let newCollabList = this.collabsList.filter(function isInCollabs(
            currentCollab
          ) {
            return (
              response.collabs.findIndex(
                (col) => col.username === currentCollab.pseudo
              ) != -1
            );
          });

          var newIdx = response.collabs.findIndex(
            (user) => user.username === this.$auth.getMyUser().username
          );
          var oldIdx = this.collabsList.findIndex(
            (user) => user.pseudo === this.$auth.getMyUser().username
          );

          //Si on est plus dans le projet après le suppression d'une équipe on est renvoyé hors du projet
          if (newIdx === -1) {
            this.$router.push("/vireed");
          } else {
            //Si mon rôle a changé je recharge le player et la sidebar (qui s'adapteront au nouveau rôle)
            if (
              this.collabsList[oldIdx].role != response.collabs[newIdx].role
            ) {
              this.userRole = response.collabs[newIdx].role;
              // this.videoPlayerKey++;
              // this.sideBarKey++;
              this.videoKey++;
            }
          }

          //On met à jour le rôle de tous les utilisateurs
          response.collabs.forEach((col) => {
            let userIdx = newCollabList.findIndex(
              (user) => user.pseudo === col.username
            );
            if (userIdx != -1) {
              newCollabList[userIdx].role = col.role;
              newCollabList[userIdx].teams = col.teams;
            }
          });

          //On vérifie que le selected user est toujours présente

          if (
            newCollabList.findIndex(
              (user) => user.pseudo === this.userSelected.pseudo
            ) === -1
          ) {
            this.updateUserList();
            this.$bvModal.hide("modal-username");
          }

          //Enfin on met à jour la liste puis les marqueurs
          this.collabsList = newCollabList;

          this.collabsList.forEach((collab, idx) => {
            style.innerHTML += `
              .video-js .vac-marker-owrap .vac-marker-wrap .vac-marker[class~="${
                collab.pseudo
              }"] {
                bottom: -${105 + idx * 60}px;
                background-color: ${collab.color}!important;
                opacity: .8!important;
                box-shadow: 7px 0 0 0 ${collab.color} inset!important;
                }
                [class~="${collab.pseudo}-color"] {
                color: ${collab.color};
                }
                [class~="${collab.pseudo}-shape"] {
                background-color: ${collab.color}!important;
                opacity: .5;
                border-color: white;
                border-radius: 5px;
                border-style: dotted;
                border-width: 1.5px;
                }`;
          });
        })
        .then(() => {
          let oldStyle = document.getElementById("collabStyle");
          if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);
          document.head.appendChild(style);
        });
    },
    reloadProjectUser() {
      let style = document.createElement("style");
      style.id = "collabStyle";

      var user = this.$auth.getMyUser();
      let userPseudo = user.username;
      this.username = user.username;
      Pservice.getUsersOfProject(
        this.$auth.token(),
        this.$route.params.projectId
      )
        .then((response) => {
          response.collabs.forEach((user, idx) => {
            console.log(user)
            let collab = {
              role: user.role,
              pseudo: user.username,
              origin: user.origin,
              color: "#" + user.color,
              initials: (user.username[0] + user.username[1]).toUpperCase(),
              isConnected: false,
              teams: user.teams,
            };
            if (collab.pseudo === userPseudo) {
              this.userRole = collab.role;
            }
            style.innerHTML += `
          .video-js .vac-marker-owrap .vac-marker-wrap .vac-marker[class~="${
            collab.pseudo
          }"] {
            bottom: -${118 + idx * 60}px;
            background-color: ${collab.color}!important;
            opacity: .8!important;
            box-shadow: 7px 0 0 0 ${collab.color} inset!important;
            }
            [class~="${collab.pseudo}-color"] {
            color: ${collab.color};
            }
            [class~="${collab.pseudo}-shape"] {
            background-color: ${collab.color}!important;
            opacity: .5;
            border-color: white;
            border-radius: 5px;
            border-style: dotted;
            border-width: 1.5px;
            }`;

            //Si l'utilisateur n'est pas déjà présent dans la liste on le rajoute
            if (
              this.collabsList.findIndex(
                (col) => col.pseudo === collab.pseudo
              ) === -1
            ) {
              this.collabsList.splice(idx, 0, collab);
              this.selected.splice(idx, 0, collab.pseudo);
              let newAnnotCount = {
                annotations: 0,
                annotationsWithComment: 0,
                comments: 0,
              };
              this.AnnotNumber[collab.pseudo] = newAnnotCount;
            } else {
              //Si l'utilisateur est déjà présent mais que les rôles sont différents on met à jours
              let oldIdx = this.collabsList.findIndex(
                (col) => col.pseudo === collab.pseudo
              );

              //Si le role ou son nombre de team a changé on le met à jour
              if (
                collab.role != this.collabsList[oldIdx].role ||
                collab.teams.length != this.collabsList[oldIdx].teams.length ||
                collab.origin != this.collabsList[oldIdx].origin
              ) {
                this.collabsList[oldIdx].role = collab.role;
                this.collabsList[oldIdx].teams = collab.teams;
                this.collabsList[oldIdx].origin = collab.origin
                //Si c'est son propre role qui a changé on recharge les composants
                if (collab.pseudo === userPseudo) {
                  this.userRole = collab.role;
                  this.videoKey++;
                }
              }
            }
          });
        })
        .then(() => {
          let oldStyle = document.getElementById("collabStyle");
          if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);
          document.head.appendChild(style);
        });
    },
    reloadProjectUserAfterTeamEdit() {
      let style = document.createElement("style");
      style.id = "collabStyle";

      //On met à jour la liste des équipes
      Pservice.getProject(
        this.$auth.token(),
        this.$route.params.projectId
      ).then((project) => {
        this.teamsProject = [];
        project.teams.forEach((team) => {
          tService
            .getTeam(this.$auth.token(), team)
            .then((team) => {
              this.teamsProject.push(team);
            })
            .catch((err) => {
              console.log(err);
            });
        });

        var user = this.$auth.getMyUser();
        let userPseudo = user.username;
        this.username = user.username;
        Pservice.getUsersOfProject(
          this.$auth.token(),
          this.$route.params.projectId
        )
          .then((response) => {
            let newCollabList = this.collabsList.filter(function isInCollabs(
              currentCollab
            ) {
              return (
                response.collabs.findIndex(
                  (col) => col.username === currentCollab.pseudo
                ) != -1
              );
            });

            var newIdx = response.collabs.findIndex(
              (user) => user.username === this.$auth.getMyUser().username
            );
            var oldIdx = this.collabsList.findIndex(
              (user) => user.pseudo === this.$auth.getMyUser().username
            );

            //Si on est plus dans le projet après l(édition) d'une équipe on est renvoyé hors du projet
            if (newIdx === -1) {
              this.$router.push("/vireed");
            } else {
              //Si mon rôle a changé je recharge le player et la sidebar (qui s'adapteront au nouveau rôle)
              if (
                this.collabsList[oldIdx].role != response.collabs[newIdx].role
              ) {
                this.userRole = response.collabs[newIdx].role;
                this.videoKey++;
              }
            }

            //On met à jour le rôle de tous les utilisateurs
            response.collabs.forEach((col) => {
              let userIdx = newCollabList.findIndex(
                (user) => user.pseudo === col.username
              );
              if (userIdx != -1) {
                newCollabList[userIdx].role = col.role;
              }
            });

            //On rajoute dans le nouveau tableaux les "nouveaux utilisateurs"
            response.collabs.forEach((user, idx) => {
              let collab = {
                role: user.role,
                pseudo: user.username,
                origin: user.origin,
                color: "#" + user.color,
                initials: (user.username[0] + user.username[1]).toUpperCase(),
                isConnected: false,
                teams: user.teams,
              };
              if (collab.pseudo === userPseudo) {
                this.userRole = collab.role;
              }

              //Si l'utilisateur est pas déjà présent dans la liste on met son rôle à jour
              if (
                newCollabList.findIndex(
                  (col) => col.pseudo === collab.pseudo
                ) === -1
              ) {
                newCollabList.splice(idx, 0, collab);
                this.selected.splice(idx, 0, collab.pseudo);
              } else {
                //Si l'utilisateur est déjà présent mais que les rôles sont différents on met à jours
                let oldIdx = newCollabList.findIndex(
                  (col) => col.pseudo === collab.pseudo
                );

              //Si le role ou son nombre de team a changé on le met à jour
              if (
                collab.role != this.collabsList[oldIdx].role ||
                collab.teams.length != this.collabsList[oldIdx].teams.length ||
                collab.origin != this.collabsList[oldIdx].origin
              ) {
                this.collabsList[oldIdx].role = collab.role;
                this.collabsList[oldIdx].teams = collab.teams;
                this.collabsList[oldIdx].origin = collab.origin
                //Si c'est son propre role qui a changé on recharge les composants
                if (collab.pseudo === userPseudo) {
                  this.userRole = collab.role;
                  this.videoKey++;
                }
              }
              }
            });

            //Enfin on met à jour la liste puis les marqueurs
            this.collabsList = newCollabList;

            //Enfin on met à jours le style pour chaque utilisateurs de la liste
            this.collabsList.forEach((collab, idx) => {
              style.innerHTML += `
                .video-js .vac-marker-owrap .vac-marker-wrap .vac-marker[class~="${
                  collab.pseudo
                }"] {
                  bottom: -${118 + idx * 60}px;
                  background-color: ${collab.color}!important;
                  opacity: .8!important;
                  box-shadow: 7px 0 0 0 ${collab.color} inset!important;
                  }
                  [class~="${collab.pseudo}-color"] {
                  color: ${collab.color};
                  }
                  [class~="${collab.pseudo}-shape"] {
                  background-color: ${collab.color}!important;
                  opacity: .5;
                  border-color: white;
                  border-radius: 5px;
                  border-style: dotted;
                  border-width: 1.5px;
                  }`;
            });
          })
          .then(() => {
            let oldStyle = document.getElementById("collabStyle");
            if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);
            document.head.appendChild(style);
          });
      });
    },
    userJoined(pseudo) {
      var idx = this.collabsList.findIndex((user) => user.pseudo === pseudo);
      if (idx != -1) {
        this.collabsList[idx].isConnected = true;
      }
    },
    userLeft(pseudo) {
      var idx = this.collabsList.findIndex((user) => user.pseudo === pseudo);
      if (idx != -1) {
        this.collabsList[idx].isConnected = false;
      }
    },
    checkEncodingPercent() {
      Pservice.getVideoFromProjectVerion(this.$auth.token(), this.uuidVideoVersion, this.$route.params.projectId).then(
        (video) => {
          
          if(video.encodingStatus != "encoded")
          {
            document.getElementById("videoPlayer").classList.add("noDisplayVideo")
          }
          if(video.encodingStatus === "encoded")
          {
            document.getElementById("videoPlayer").classList.remove("noDisplayVideo")
          }

          if(this.statusVideo != "encoded" && this.statusVideo != "" && video.encodingStatus === "encoded")
            this.mustRefresh = true;

          this.statusVideo = video.encodingStatus;

          if (this.mustRefresh === true && video.encodingStatus === "encoded") {
            this.$router.go(0);
            //this.changeVersion();
            //this.videoKey+=1;
          }
        }
      );
    },
    popupWindow(index) {
      window.open(
        "#/chat/" + this.$route.params.projectId,
        "Chat",
        "width=1200, height=750"
      );
    },
    countAnnotations(annotCount) {
      this.collabsList.forEach((collab) => {
        if (collab.pseudo in annotCount) {
          this.AnnotNumber[collab.pseudo] = annotCount[collab.pseudo];
        } else {
          let userCount = {
            annotations: 0,
            comments: 0,
            annotationsWithComment: 0,
          };
          this.AnnotNumber[collab.pseudo] = userCount;
        }
      });

      this.totalAnnotCount = {
        annotations: 0,
        comments: 0,
        annotationsWithComment: 0,
      };

      for (const userAnnot in this.AnnotNumber) {
        this.totalAnnotCount.annotations +=
          this.AnnotNumber[userAnnot].annotations;
        this.totalAnnotCount.comments += this.AnnotNumber[userAnnot].comments;
        this.totalAnnotCount.annotationsWithComment +=
          this.AnnotNumber[userAnnot].annotationsWithComment;
      }
    },
    cancelTitle() {
      this.newName = "";
      this.updateProjectTitle = false;
    },

    updateTitle() {
      this.updateProjectTitle = false;
      var body = { name: this.newName };
      Pservice.updateProject(this.$auth.token(), this.projectId, body).then(
        (res) => {
          if (this.$socket != undefined || this.$socket != null) {
            this.$socket.emit("projectInfoUpdated");
          }
          this.name = this.newName;
        }
      );
    },
    reloadProjectInfo() {
      Pservice.getProject(this.$auth.token(), this.$route.params.projectId)
        .then((project) => {
          this.name = project.name;
          this.description = project.description;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    cancelDescription() {
      this.newDescription = "";
      this.updateProjectDescription = false;
    },

    updateDescription() {
      this.updateProjectDescription = false;
      var body = { description: this.newDescription };
      Pservice.updateProject(this.$auth.token(), this.projectId, body).then(
        (res) => {
          if (this.$socket != undefined || this.$socket != null) {
            this.$socket.emit("projectInfoUpdated");
          }
          this.description = this.newDescription;
        }
      );
    },
  },

  beforeMount() {
    EventBus.$on("newAnnotationCount", this.countAnnotations);

    this.totalAnnotCoun = {
      annotations: 0,
      comments: 0,
      annotationWithComments: 0,
    };

    Pservice.getProject(this.$auth.token(), this.$route.params.projectId)
      .then((project) => {
        this.name = project.name;
        this.description = project.description;
        let versions = project.versions;
        let currentVersion = versions.find(
          (version) => version.number == this.projectVersion
        );
        this.owner = project.user;
        this.uuidVideoVersion = currentVersion.uuidVideo;
        this.checkEncodingPercent();

        this.createdAt = moment(project.createdDate).format("DD/MM/YY @HH:mm");

        if (project.lastUpdated)
          this.lastUpdated = moment(project.lastUpdated).format(
            "DD/MM/YY @HH:mm"
          );

        project.teams.forEach((team) => {
          tService
            .getTeam(this.$auth.token(), team, this.$route.params.projectId)
            .then((team) => {
              this.teamsProject.push(team);
            })
            .catch((err) => {
              console.log(err);
            });
        });

        Vservice.getVideoManifest(currentVersion.uuidVideo, this.$auth.token())
          .then((video) => {
            this.videoTitle = video.title;
            this.noVideo = false;
            this.videoKey += 1;
            this.post = {
              playerOptions: {
                autoplay: true,
                controls: true,
                techOrder: ["html5"],
                sources: [
                  {
                    //src: "/v/videos/" + this.$route.params.projectId + "/" + version,
                    src: video.m3u8,
                    type: "application/x-mpegurl",
                  },
                ],
                controlBar: {
                  // inline volume to prevent timeline width change
                  volumePanel: { inline: false },
                  pictureInPictureToggle: false,
                  currentTime: true,
                },
              },
            };
          })
          .catch((err) => {
            this.noVideo = true;
            document.getElementById("videoPlayer").classList.add("noDisplayVideo")
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });

    let oldStyle = document.getElementById("collabStyle");
    if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);
    let style = document.createElement("style");
    style.id = "collabStyle";

    var user = this.$auth.getMyUser();
    let userPseudo = user.username;
    this.username = user.username;
    this.initials = (this.username[0] + this.username[1]).toUpperCase();
    this.colorAvatar = "#" + user.color;
    Pservice.getUsersOfProject(this.$auth.token(), this.$route.params.projectId)
      .then((response) => {
        response.collabs.forEach((user, idx) => {
          let collab = {
            role: user.role,
            pseudo: user.username,
            origin: user.origin,
            color: "#" + user.color,
            initials: (user.username[0] + user.username[1]).toUpperCase(),
            isConnected: false,
            teams: user.teams,
          };
          if (collab.pseudo === userPseudo) {
            this.userRole = collab.role;
          }
          style.innerHTML += `
          .video-js .vac-marker-owrap .vac-marker-wrap .vac-marker[class~="${
            collab.pseudo
          }"] {
            bottom: -${118 + idx * 60}px;
            background-color: ${collab.color}!important;
            opacity: .8!important;
            box-shadow: 7px 0 0 0 ${collab.color} inset!important;
            }
            [class~="${collab.pseudo}-color"] {
            color: ${collab.color};
            }
            [class~="${collab.pseudo}-shape"] {
            background-color: ${collab.color}!important;
            opacity: .5;
            border-color: white;
            border-radius: 5px;
            border-style: dotted;
            border-width: 1.5px;
            }`;
          this.collabsList.push(collab);
          this.selected.push(collab.pseudo);
        });
      })
      .then(() => {
        document.head.appendChild(style);
      });
    /**.then(() => {
        fetch(url_pu)
          .then((res) => {
            if (res.status === 200) {
              console.log(res);
              res.json().then((usersList) => {
                usersList.forEach((user, idx) => {
                  let collab = {
                    role: user.role,
                    pseudo: user.user.pseudo,
                    id: user.user.id,
                    mail: user.user.email,
                    initials: (
                      user.user.firstname[0] + user.user.lastname[0]
                    ).toUpperCase(),
                    color: "#" + user.user.color,
                  };
                  if (collab.pseudo === userPseudo) {
                    this.userRole = collab.role;
                  }
                  style.innerHTML += `
                .video-js .vac-marker-owrap .vac-marker-wrap .vac-marker[class~="${
                  collab.pseudo
                }"] {
                  bottom: -${130 + idx * 75}px;
                  background-color: ${collab.color}!important;
                  opacity: .8!important;
                  box-shadow: 7px 0 0 0 ${collab.color} inset!important;
                }
                [class~="${collab.pseudo}-color"] {
                  color: ${collab.color};
                }
                [class~="${collab.pseudo}-shape"] {
                  background-color: ${collab.color}!important;
                  opacity: .5;
                  border-color: white;
                  border-radius: 5px;
                  border-style: dotted;
                  border-width: 1.5px;
                }`;
                  this.collabsList.push(collab);
                  this.selected.push(collab.pseudo);
                });
                this.callNumber = this.collabsList.length;
                this.callNumberAdjust = this.collabsList.length;
              });
            }
          })
          .then(() => {
            document.head.appendChild(style);
          });
      });**/

    /**
    let url_u = "/a/user";
    fetch(url_u).then((res) => {
      if (res.status === 200) {
        res.json().then((data) => {
          this.username = data.pseudo;
        });
      }
    });**/
  },
  mounted() {
      this.intervalCheckEncodingPercent = setInterval(
        this.checkEncodingPercent,
        5000
      );
  },
  beforeDestroy() {
    try {
      clearInterval(this.intervalCheckEncodingPercent);
    } catch (e) {}
  },
};
</script>

<style lang="scss" scoped>
.video-js {
  width: 100%;
  margin: 0;
}
#content {
  margin-left: 0px;
}
#content {
  #collabsList {
    position: sticky;
    height: max-content;
    background-color: var(--v-background-base);
    border-radius: 5px 0 0 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    #ProjectInfo {
      h3 {
        margin-top: 125px;
        background-color: rgba(0, 0, 0, 0.5);
        color: white;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
    }

    #call {
      margin-top: 10px;
      h4 {
        color: var(--v-secondary-base);
        margin-bottom: 15px;
      }
    }
    #actions {
      margin-top: 10px;
      margin-left: 15px;
      h4 {
        color: var(--v-secondary-base);
        margin-bottom: 15px;
      }
    }
    #videoChatServer {
      color: var(--v-secondary-base);
      margin-bottom: 0;
    }

    #collaborators {
      h4 {
        color: var(--v-secondary-base);
        margin-bottom: 0;
      }

      ul {
        list-style: none;
        display: inline;

        li {
          margin-top: 10px;
          margin-right: 15px;
          //   border-bottom: solid black;
          .icons {
            float: right;
          }

          #role {
            font-style: italic;
            color: rgb(100, 100, 100);
          }
        }
      }
    }

    #deleteProject {
      margin-left: 8%;
      margin-top: 20px;
    }

    #addVideo {
      margin-left: 8%;
      margin-top: 15px;
    }
  }
}

.teams {
  h4 {
    color: var(--v-secondary-base);
    margin-bottom: 0;
  }

  ul {
    list-style: none;
    display: inline;

    li {
      margin-top: 10px;
      margin-right: 15px;
    }
  }
}

.hr-user {
  margin-right: 10px;
}

.divGlobal-user {
  width: 100%;
  margin-top: 25px;
}

.sideButton {
  min-width: 20px !important;
  height: 25px !important;
  vertical-align: bottom;
  text-transform: none !important;
  letter-spacing: normal !important;
}

.status {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  z-index: 2;
}

.disconnected {
  background-color: lightgray;
}

.connected {
  background-color: lawngreen;
}

.divBreak  {
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}

span[data-descr] {
  position: relative;
}

span[data-descr]:hover::after {
  content: attr(data-descr);
}

#time {
  width: 3px;
  background: red;
  height: 100%;
  position: absolute;
  left: 173px;
}

.noDisplayVideo {
  display:none;
}

</style>